import React, { useState, useEffect } from 'react'
import swal from 'sweetalert'
import { superAxiosRequest } from 'axiosApi'
import { dateFormat } from 'helpers/date'
import { localisationMaster } from 'Localisation/Localisation'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import InputInn from 'components/Modules/Auth/SignUp/InputInn/InputInn'
import st from './InvoiceDetails.module.scss'
import cogoToast from 'cogo-toast'
import { ReactComponent as Warning } from 'components/UI/icons/error-warning-line.svg'
import InvoiceTicketDetail from './InvoiceTicketDetail/InvoiceTicketDetail'
import InvoiceDetailInf from './InvoiceDetailInf/InvoiceDetailInf'
import PayServiceSection from './PayServiceSection/PayServiceSection'
import CheckPayStatusSection from './CheckPayStatusSection/CheckPayStatusSection'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormSelectCustom from 'components/UI/AsideModal/Form/FormSelectCustom'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const initOptionsPayers = [
  {
    id: 9000000,
    label: localisationMaster('create_new_payer', 'pays/invoice'),
  },
]

const initUserData = {
  last_name: '',
  first_name: '',
  inn: '',
  who_is_it: '',
  email: '',
  phone: '',
  address: '',
}

const statuses = {
  PAID: 'paid',
  NOT_PAID: 'not_paid',
  CANCELED: 'cancelled',
}

export default function InvoiceDetails(props) {
  const link = 'online-schedule/record-customer-error'

  const [orderData, setOrderData] = useState(false)
  const [banks, setBanks] = useState([])
  const [paymentType, setPaymentType] = useState(1)
  const [checkStatusBlock, setCheckStatusBlock] = useState(false)
  const [timer, setTimer] = useState(0)
  const [user, setUser] = useState(initUserData)
  const [clientData, setClientData] = useState({})
  const [payerID, setPayerID] = useState(0)
  const [contacts, setContacts] = useState(initOptionsPayers)
  const [aError, setErrors] = useState([])
  const [contactPersonId, setContactPersonId] = useState(null)

  const isNotPaid = orderData.status_order === statuses.NOT_PAID

  const changeUserHandler = (val, name) => {
    setUser({ ...user, [name]: val })
  }

  const getOrderStatus = () => {
    const api = {
      link: 'payments/order_status/' + props.match.params.id,
      method: 'get',
    }
    superAxiosRequest(api)
      .then(({ data: { result, banks } }) => {
        const r = result
        setOrderData(r)
        const userData = {
          last_name: r.last_name,
          first_name: r.first_name,
          inn: r.inn,
          who_is_it: '',
          phone: r.phone,
          email: r.email,
          address: r.address,
        }
        setUser(userData)
        setClientData(userData)
        setPaymentType(r.bank)
        setBanks(banks)
        r.payer_id !== null && setPayerID(r.payer_id)
      })
      .catch()
  }

  const checkOrder = () => {
    superAxiosRequest({
      method: 'get',
      link: `payments/order_status/${props.match.params.id}`,
    })
      .then((res) => {
        setTimer(5)
        setOrderData(res.data.result)
        setPaymentType(res.data.result.bank)
      })
      .catch()
  }

  const cancelOrder = () => {
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `Вы действительно хотите отменить счет?`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          method: 'put',
          link: `payments/pay_orders/${orderData.id}`,
        }
        superAxiosRequest(apiConf, { status_order: 'cancelled' }).then(() => {
          getOrderStatus()
          swal('', 'Счет успешно отменен', 'success').then(() => {})
        })
      } else {
        swal('Действие отменено').then(() => {})
      }
    })
  }

  const changeHandlerPayer = (o) => {
    if (o.id === 9000000) {
      setUser(initUserData)
      setPayerID(o.id)
      setContactPersonId(null)
    } else {
      setUser({
        first_name: o.data.first_name,
        inn: o.data.inn,
        last_name: o.data.last_name,
        phone: o.data.phone,
        email: o.data.email,
        who_is_it: o.data.who_is_it,
        address: o.data.address,
      })
      setPayerID(o.id)
      setContactPersonId(o.data.id)
    }
  }

  const handleSubmit = () => {
    const bank = banks.find((b) => b.id === paymentType)

    if (!bank) {
      checkChoosingBank()
      return
    }

    if (payerID === 9000000) {
      superAxiosRequest(
        {
          link: 'accounts/contact_persons',
          method: 'post',
        },
        {
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          inn: user.inn,
          phone: user.phone,
          who_is_it: user.who_is_it,
          user: orderData.user_id,
          address: user.address,
        },
      )
        .then((response) => {
          const newContactPersonId = response.data.id
          setContactPersonId(newContactPersonId)

          proceedWithPayment(newContactPersonId, bank)
        })
        .catch((error) => {
          console.error('Error creating contact person:', error)
        })
    } else {
      proceedWithPayment(contactPersonId, bank)
    }
  }

  const proceedWithPayment = (contactPersonId, bank) => {
    if (bank) {
      if (bank.name.indexOf('Kaspi') !== -1) {
        setCheckStatusBlock(true)
      } else {
        if (contactPersonId !== null) {
          const apiConf = {
            link: `payments/order_change_payer/${props.match.params.id}`,
            method: 'put',
          }
          superAxiosRequest(apiConf, { contact_person: contactPersonId })
            .then(() => {
              openInvoiceUrl()
            })
            .catch((error) => {
              console.error('Error updating payer:', error)
            })
        } else {
          openInvoiceUrl()
        }
      }
    } else {
      checkChoosingBank()
    }
  }

  const openInvoiceUrl = () => {
    let a
    a = document.createElement('a')
    a.target = '_blank'
    a.href = orderData.invoice_url
    a.click()
  }
  const checkChoosingBank = () => {
    const currentToast = cogoToast.error(
      <div className='cogo_toast_error'>
        <div className='cogo_toast_message'>
          <div className='warning_cogo_toast_message'>
            <Warning />
          </div>
          <span>Выберите способ оплаты</span>

          <button
            className='cogo_toast_button'
            onClick={() => currentToast.hide()}
          >
            OK
          </button>
        </div>
        <div
          className='cogo_toast_overlay'
          onClick={() => currentToast.hide()}
        ></div>
      </div>,
      {
        hideAfter: 0,
      },
    )
  }

  function isValidEmail(email) {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailRegex.test(String(email).toLowerCase())
  }

  const validate = () => {
    const aError = []

    // Фамилия
    if (!!!user.last_name || user.last_name.length < 2)
      aError.push({
        field: localisationMaster('text-4', link),
        desc: localisationMaster('text-5', link),
      })

    // Имя
    if (!!!user.first_name || user.first_name.length < 2)
      aError.push({
        field: localisationMaster('text-2', link),
        desc: localisationMaster('text-3', link),
      })

    // Email
    if (!isValidEmail(user.email))
      aError.push({
        field: localisationMaster('text_27', 'company/locations'),
        desc: localisationMaster('email_valid', 'pays/invoice'),
      })

    if (!user.inn || user.inn.length !== 12)
      aError.push({
        field: localisationMaster('table-row-title-5', 'company/companies'),
        desc: localisationMaster('text-5', 'pays/invoice'),
      })

    // Телефон
    if (!!!user.phone || user.phone?.length < 7 || user.phone?.length > 15)
      aError.push({
        field: localisationMaster('text-7', link),
        desc: localisationMaster('text-8', link),
      })

    if (!!!user.who_is_it || user.who_is_it?.length < 3)
      aError.push({
        field: localisationMaster(
          'whois',
          'company/profiles/account',
          'add_category',
        ),
        desc: localisationMaster('text-6', 'pays/invoice'),
      })

    setErrors(aError)
  }

  const checkboxHandler = () => {
    if (payerID === 0) {
      setUser(initUserData)
      setPayerID(9000000)
    }
    if (payerID > 0) {
      setErrors([])
      setUser({ ...clientData })
      setPayerID(0)
    }
  }

  useEffect(() => {
    if (!orderData.user_id || orderData.status_order === statuses.PAID) return
    superAxiosRequest({
      link: 'accounts/contact_persons',
      method: 'get',
      params: {
        user_id: orderData.user_id,
      },
    })
      .then((res) => {
        const list = res.data.result.map((el) => ({
          id: el.id,
          label: `${el.first_name} ${el.last_name}`,
          data: el,
        }))
        setContacts([...initOptionsPayers, ...list])
      })
      .catch()
  }, [orderData])

  useEffect(() => {
    if (payerID !== 0 && payerID < 9000000 && contacts.length > 1) {
      setErrors([])
      const dataC = contacts.find((x) => x.id === payerID)?.data
      setUser({
        first_name: dataC.first_name,
        inn: dataC.inn,
        last_name: dataC.last_name,
        phone: dataC.phone,
        email: dataC.email,
        who_is_it: dataC.who_is_it,
      })
    }
  }, [payerID, contacts])

  useEffect(() => {
    payerID === 9000000 && validate()
  }, [payerID, user])

  useEffect(() => {
    getOrderStatus()
  }, [])

  useEffect(() => {
    if (timer < 1) return
    setTimeout(() => setTimer(timer - 1), 1000)
  }, [timer])

  const isDisabled = payerID > -1 && payerID < 9000000

  const innOptions = [
    { id: 1, name: 'IIN' },
    { id: 2, name: 'INN' },
  ]

  const menu = [
    {
      name: localisationMaster('cancel_invoice', 'pays/invoice'),
      action: 'cancel_invoices',
    },
    {
      name: localisationMaster('go_to_payment', 'pays/invoice'),
      action: 'go_to_payments',
    },
  ]

  const action = (action) => {
    const actions = new Map([
      ['cancel_invoices', () => cancelOrder()],
      ['go_to_payments', () => handleSubmit()],
    ])
    return actions.get(action)?.()
  }

  return (
    <div className={st.container}>
      {orderData.status_order === statuses.PAID && (
        <div className={st.accountNoBox}>
          <div className={st.accountDataTime}>
            <div
              className={st.accountNo}
            >{`Invoice №: ${props.match.params.id}`}</div>
            <div className={st.createdAt}>
              {localisationMaster('info-date', 'pays/payment/answer')}:{' '}
              {dateFormat(
                new Date(
                  orderData.payment_date
                    ? orderData.payment_date
                    : orderData.created_at,
                ),
                'dd MMMM YYYY г.',
              )}
            </div>
          </div>
        </div>
      )}
      {orderData.status_order === statuses.CANCELED && (
        <div className={st.accountNoBox}>
          <div className={st.accountDataTime}>
            <div
              className={st.accountNo}
            >{`Invoice №: ${props.match.params.id}`}</div>
            <div className={st.createdAt}>
              {localisationMaster('info-date', 'pays/payment/answer')}:{' '}
              {dateFormat(
                new Date(
                  orderData.payment_date
                    ? orderData.payment_date
                    : orderData.created_at,
                ),
                'dd MMMM YYYY г.',
              )}
            </div>
          </div>
        </div>
      )}
      {!checkStatusBlock && isNotPaid && (
        <div className={st.accountNoBox}>
          <div className={st.infAccount}>
            <div className={st.partInf}>
              <div className={st.accountDataTime}>
                <div
                  className={st.accountNo}
                >{`Invoice №: ${props.match.params.id}`}</div>
                {orderData && (
                  <div className={st.createdAt}>
                    {localisationMaster('info-date', 'pays/payment/answer')}:{' '}
                    {dateFormat(
                      new Date(
                        orderData.payment_date
                          ? orderData.payment_date
                          : orderData.created_at,
                      ),
                      'dd MMMM YYYY г.',
                    )}
                  </div>
                )}
              </div>
              <div className={st.actionMenu}>
                <ActionMenu menu={menu} action={action} />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={st.invoicePage}>
        <div
          className={`${isNotPaid ? st.accountNotPayBox : orderData.status_order === statuses.PAID ? st.accountPayBox : st.accountFullWidthBox}`}
        >
          <div className={st.payBox}>
            <InvoiceTicketDetail
              order={orderData}
              checkOrder={checkOrder}
              cancelOrder={cancelOrder}
              timer={timer}
            />
            {isNotPaid && (
              <PayServiceSection
                banks={banks}
                onChange={setPaymentType}
                value={paymentType}
              />
            )}
          </div>
        </div>
        {orderData.status_order === statuses.PAID && (
          <div className={st.accountPayBoxTwo}>
            <InvoiceDetailInf {...orderData} />
          </div>
        )}
        {isNotPaid && (
          <>
            {/*<PayServiceSection banks={banks} onChange={setPaymentType} value={paymentType} />*/}
            <div className={st.accountContactBox}>
              <div className={st.payerData}>
                <div className={st.customBox}>
                  <div className={st.customerData}>
                    {localisationMaster('payer_data', 'pays/invoice')}
                  </div>
                  <ToggleCheckbox
                    label={localisationMaster(
                      'customer_and_payer',
                      'pays/invoice',
                    )}
                    checked={payerID === 0}
                    onChange={checkboxHandler}
                  />
                </div>
                <div className={st.customerFolder}>
                  <FormField>
                    <FormLabel>Creating a new payer</FormLabel>
                    <FormSelectCustom>
                      <SelectCustom
                        placeholder={localisationMaster(
                          'customer_payers',
                          'pays/invoice',
                        )}
                        options={contacts}
                        valueID={payerID}
                        onChange={(o) => changeHandlerPayer(o)}
                        isSearchable
                      />
                    </FormSelectCustom>
                  </FormField>
                  <div className={st.contactsField}>
                    <div className={st.contacts}>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired>
                            {localisationMaster(
                              'text-4',
                              'online-schedule/record-customer-error',
                            )}
                            :
                          </FormLabel>
                          <FormInput>
                            <input
                              type='text'
                              disabled={isDisabled}
                              placeholder={localisationMaster(
                                'placeholder-5',
                                'online-schedule/record-customer',
                              )}
                              value={user.last_name}
                              onChange={(e) =>
                                changeUserHandler(e.target.value, 'last_name')
                              }
                            />
                          </FormInput>
                        </FormField>
                      </div>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired>
                            {localisationMaster(
                              'text-2',
                              'online-schedule/record-customer-error',
                            )}
                            :
                          </FormLabel>
                          <FormInput>
                            <input
                              type='text'
                              disabled={isDisabled}
                              placeholder={localisationMaster(
                                'table-row-title-3',
                                'pays/all-pays',
                              )}
                              value={user.first_name}
                              onChange={(e) =>
                                changeUserHandler(e.target.value, 'first_name')
                              }
                            />
                          </FormInput>
                        </FormField>
                      </div>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired>
                            {localisationMaster(
                              'table-row-title-5',
                              'company/companies',
                            )}
                            :
                          </FormLabel>
                          <InputInn
                            value={user.inn || ''}
                            onChange={(val) => changeUserHandler(val, 'inn')}
                            disabled={isDisabled}
                            options={innOptions}
                          />
                        </FormField>
                      </div>
                    </div>
                    <div className={st.contacts}>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired>
                            {' '}
                            {localisationMaster(
                              'whois',
                              'company/profiles/account',
                              'add_category',
                            )}
                            :
                          </FormLabel>
                          <FormInput>
                            <input
                              disabled={isDisabled}
                              placeholder={localisationMaster(
                                'whois',
                                'company/profiles/account',
                                'add_category',
                              )}
                              value={user.who_is_it || ''}
                              onChange={(e) =>
                                changeUserHandler(e.target.value, 'who_is_it')
                              }
                              className='fieldsetCustomer__input'
                            />
                          </FormInput>
                        </FormField>
                      </div>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired> E-mail:</FormLabel>
                          <FormInput>
                            <input
                              disabled={isDisabled}
                              placeholder='E-mail'
                              value={user.email}
                              onChange={(e) =>
                                changeUserHandler(e.target.value, 'email')
                              }
                              className='fieldsetCustomer__input'
                            />
                          </FormInput>
                        </FormField>
                      </div>
                      <div className={st.widthInp}>
                        <FormField>
                          <FormLabel isRequired>
                            {localisationMaster('text_55', 'modal_templates')}:
                          </FormLabel>
                          <FormInput>
                            <InputFlagPhone
                              disabled={isDisabled}
                              value={user.phone}
                              onChange={(e) => changeUserHandler(e, 'phone')}
                            />
                          </FormInput>
                        </FormField>
                      </div>
                    </div>
                  </div>
                  {payerID !== 0 && (
                    <FormField>
                      <FormLabel isRequired>Address:</FormLabel>
                      <FormInput>
                        <input
                          disabled={isDisabled}
                          placeholder={'Address'}
                          value={user.address || ''}
                          onChange={(e) =>
                            changeUserHandler(e.target.value, 'address')
                          }
                          className='fieldsetCustomer__input'
                        />
                      </FormInput>
                    </FormField>
                  )}
                  {aError.length > 0 && (
                    <div className={st.fieldError}>
                      {aError.map((error, index) => (
                        <div key={index} className={st.listErrors}>
                          <div className={st.fields}>{error.field}:</div>
                          <div className={st.fields}>{error.desc}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {checkStatusBlock && (
                  <CheckPayStatusSection
                    payerID={payerID}
                    userID={contactPersonId}
                    orderID={props.match.params.id}
                    closeOrder={() => setCheckStatusBlock(!checkStatusBlock)}
                    isDisableCounter
                  />
                )}

                <div className={st.btnContainer}>
                  <div className={st.buttons}>
                    <div>
                      {orderData.status_order === 'not_paid' &&
                        checkPermList(permissions.change_invoice) && (
                          <button
                            className={`${aError.length > 0 ? 'disabled' : ''} ${st.goToPayment}`}
                            onClick={cancelOrder}
                            // onClick={!aError.length > 0 ? cancelOrder : null}
                          >
                            {localisationMaster(
                              'cancel_invoice',
                              'pays/invoice',
                            )}
                          </button>
                        )}
                    </div>
                    <div>
                      <button
                        disabled={aError.length > 0}
                        className={`${aError.length > 0 ? 'disabled' : ''} ${st.goToPayment}`}
                        onClick={handleSubmit}
                      >
                        {localisationMaster('go_to_payment', 'pays/invoice')}
                      </button>
                    </div>
                  </div>

                  <div className={st.switching}>
                    {localisationMaster('text-7-1', 'pays/invoice')} &nbsp; 20{' '}
                    {localisationMaster(
                      'minutes',
                      'online-schedule/time-slots',
                    )}
                    {localisationMaster('text-7-2', 'pays/invoice')}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
